// extracted by mini-css-extract-plugin
export default {"Role":"Role_Role__yQvMH","Role_portfolio":"Role_Role_portfolio__zmCTA","Role__Letters":"Role_Role__Letters__Ahj2g","Role__Letters_portfolio":"Role_Role__Letters_portfolio__wS8et"};